import React__default from 'react';
import isEmpty from 'lodash/isEmpty';
import { Types } from '@grandvisionhq/auth';
import { useDispatch, useFeatureToggles, useSelector } from '@grandvisionhq/state';
import { ShippingObjectTypes } from '../../state.js';
import { togglePrefill } from '../actions.js';
import { getShippingDetails, isUserDataPrefilled } from '../selectors.js';
import { PrefillSources } from '../types.js';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';

const useFormPrefill = (userData)=>{
    const checkoutSettings = useCheckoutSettings();
    const dispatch = useDispatch();
    const { isAddressBookEnabled  } = useFeatureToggles();
    const shippingDetails = useSelector(getShippingDetails);
    const isUserDataPrefilledBoolean = useSelector(isUserDataPrefilled);
    React__default.useEffect(()=>{
        if (!shippingDetails || isUserDataPrefilledBoolean) {
            return;
        }
        /**
     *  Prefill information from the opco context
     */ const shippingDetailsCart = checkoutSettings.shippingDetails;
        /**
     *  Prefill with user data from cart
     */ if (shippingDetailsCart && !isEmpty(shippingDetailsCart)) {
            /**
       *  Determines which auth forms will be merged into the checkout forms.
       *  If address book is enabled, prefill BillingAddress with preferred billing address from the address book
       *  Otherwise, prefill BillingAddress with data from MyAccount personal details
       */ const billingPrefillRequired = (shippingDetailsCart === null || shippingDetailsCart === void 0 ? void 0 : shippingDetailsCart.billingAddress) ? !isEmpty(shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.billingAddress.formData) : true;
            const customerPrefillRequired = (shippingDetailsCart === null || shippingDetailsCart === void 0 ? void 0 : shippingDetailsCart.customer) ? !isEmpty(shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.contactDetails.formData) : true;
            const deliveryPrefillRequired = (shippingDetailsCart === null || shippingDetailsCart === void 0 ? void 0 : shippingDetailsCart.deliveryAddress) ? !isEmpty(shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.deliveryAddress.formData) : true;
            if (billingPrefillRequired && customerPrefillRequired && deliveryPrefillRequired) {
                const mapping = {
                    billingAddress: ShippingObjectTypes.BillingAddress,
                    deliveryAddress: ShippingObjectTypes.DeliveryAddress,
                    customer: ShippingObjectTypes.ContactDetails
                };
                Object.entries(mapping).forEach(([sourceFormName, checkoutFormName])=>{
                    var ref;
                    dispatch(togglePrefill({
                        source: PrefillSources.Cart,
                        email: (ref = shippingDetailsCart.customer) === null || ref === void 0 ? void 0 : ref.email,
                        data: shippingDetailsCart,
                        targetFormState: shippingDetails[checkoutFormName],
                        sourceFormName,
                        targetFormName: checkoutFormName
                    }));
                });
            }
        }
        /**
     *  Prefill with user data from MyAccount
     */ if (userData && isEmpty(shippingDetailsCart)) {
            const { result  } = userData;
            /**
       *  Determines which auth forms will be merged into the checkout forms.
       *  If address book is enabled, prefill BillingAddress with preferred billing address from the address book
       *  Otherwise, prefill BillingAddress with data from MyAccount personal details
       */ const mapping = isAddressBookEnabled ? {
                [Types.FormName.personalDetails]: ShippingObjectTypes.ContactDetails
            } : {
                [Types.FormName.billingAddress]: ShippingObjectTypes.BillingAddress,
                [Types.FormName.personalDetails]: ShippingObjectTypes.ContactDetails
            };
            Object.entries(mapping).forEach(([authFormName, checkoutFormName])=>{
                if (!checkoutFormName) {
                    return;
                }
                dispatch(togglePrefill({
                    source: PrefillSources.UserData,
                    email: result.email,
                    data: result,
                    targetFormState: shippingDetails[checkoutFormName],
                    sourceFormName: authFormName,
                    targetFormName: checkoutFormName
                }));
            });
        }
    // Added eslint rule because shipping details in the dependency array triggers an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userData === null || userData === void 0 ? void 0 : userData.status,
        checkoutSettings,
        dispatch
    ]);
};

export { useFormPrefill };
//# sourceMappingURL=use-form-prefill.js.map
